export default __webpack_public_path__ + "static/media/Covert Leggings.5caf67ff.jpg";